<template> 
<div id="thankYouPage" style="background: #E9F1F4;min-height: 600px;padding-bottom:50px;">
		<div class="row">
            <div class="col-lg-2 col-xl-2">
            </div>
			<div class="col-lg-8 col-xl-8 thankYouContainer" >
                <h1 v-if="!isEnquiry">{{strings.congratulations}} </h1>
                <h1 v-if="isEnquiry">{{strings.thankYou}}</h1>
                <h1 v-if="!isEnquiry" >{{strings.yourBookingIsComplete}}</h1>
                 <h1 v-if="isEnquiry" >{{strings.yourRequestHasBeenSent}}</h1>
                <div class="paragraph"> 
                    <div class="paragraph-title">{{strings.yourOrderNumber}}</div>
                    <div v-for="event in events">{{event.order_id}}</div>
                </div>
                <div class="paragraph sub-paragraph"> 
                    <div class="paragraph-title">{{strings.whatHappensNow}}</div>
                    <ol>
                        <li v-if="!isEnquiry">{{strings.thankYouBulletOne}}</li>
                        <li v-if="isEnquiry">{{strings.youWillReceiveInformationInEmail}}</li>
                        <li>{{strings.thankYouBulletTwo}}</li>
                        <li>{{strings.thankYouBulletThree}}</li>
                    </ol>
                </div>
                <div class="paragraph"> 
                    <button v-if='!isEnquiry' @click="gotoVenueUrl()" class="ctaEnquiry">{{strings.bookAnotherMeeting}}</button>
                     <button v-if='isEnquiry' @click="gotoVenueUrl()" class="ctaEnquiry">{{strings.anotherEnquiry}}</button>
                    <a @click="gotoStartPage($event)" :href="startpageUrl" class="returnBtn">{{strings.goToStartPage}}</a>
                </div>
			</div>
            <div class="col-lg-2 col-xl-2">
            </div>
		</div>	
</div>
</template>

<script>


export default {
	data () {
		return {
            venueUrl: '',
            startpageUrl: ''
		}
    },
    mounted(){
        var element = document.getElementById("thankYouPage");        
        var top = element.offsetTop;
        window.scrollTo(0, top);
        this.venueUrl = this.$cookie.get('venue_redirect_url');
        let language_array = ['en', 'en-us', 'da', 'fi', 'fr', 'de', 'it', 'lv', 'ru', 'es', 'sv', 'zh', 'tr', 'cs', 'nb', 'et', 'nl', 'pl', 'sk', 'sl', 'hu'];
        let path = this.$route.path.substring(1);
        let array_path = path.split('/');
        let lang = '';
        let route = this.$route;
        if(language_array.includes(array_path[0])){
            lang = array_path[0];
        }
		let site_url = window.location.protocol + '//' + window.location.hostname;
        site_url += (lang != '') ? '/'+ lang: '';
        this.startpageUrl = site_url;

    },
	computed: {
		strings(){
            return this.$store.state.strings;
        },
        events(){
            return this.$store.state.checkoutDetails.events;
        },
        isEnquiry(){
            return this.$store.state.checkoutDetails.enquiry;
        },
	},
	methods: {
        gotoVenueUrl: function(){
          localStorage.removeItem('checkoutDetails');
          window.location.href = this.venueUrl;
        },
        gotoStartPage: function(event){
          event.preventDefault();
          localStorage.removeItem('checkoutDetails');
          window.location.href = this.startpageUrl;
        }
	}
}
</script>


<style scoped>
    .thankYouContainer{
		background: #fff;
		padding: 30px;
        text-align:center;
        margin-top:70px;
        color: #395D68;
	}
    .thankYouContainer h1{
        color: #002F3C;
        font-size: 28px;
    }
    .paragraph{
        margin-top:30px;
    }
    .thankYouContainer ol{
        padding-top: 10px;
        text-align: center;
        list-style-position: inside;
    }
    .paragraph-title{
        font-weight: 600;
        color:#03323F;
    }
    .ctaEnquiry{
        color: #fff;
        border: none;
        background-color: #00aa50;
        border-radius: unset;
        font-size: 16px;
        padding: 10px;
        outline: none;
        margin-left: auto;
        margin-right: auto;
        float: none;
        display: block;
    }
    .returnBtn{
        color:#03323F;
        font-weight:500px;
        border-bottom: 1px solid #00AA50;
    }
    .returnBtn:hover, .returnBtn:active{
        text-decoration: none;
        outline: none;
    }
    .sub-paragraph{
        margin-top:20px;
    }

</style>
<style>

</style>

